import { WHY } from "@/constants/testIds";
import { MarketFriezeMini } from "@/components/landing/MarketFrieze";
import { useContent } from "@/context/ContentContext";

export const WhyZafara = () => {
  const { content } = useContent();
  const BLOCKS = (content.whyBlocks || []).map((b, i) => ({
    ...b,
    color: i % 2 === 0 ? "#0E7A3B" : "#F5A800",
  }));

  return (
    <section
      id="why"
      data-testid={WHY.root}
      className="relative py-24 md:py-36 bg-white border-y border-[#EDE7D9]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#0E7A3B] flex items-center gap-2">
            <span className="h-px w-8 bg-[#0E7A3B]" />
            Pourquoi « Zafara » ?
          </p>
          <h2 className="mt-5 font-display text-4xl md:text-6xl lg:text-7xl text-[#16241B] leading-[1] tracking-tighter">
            Un nom pensé pour
            <br />
            <span className="text-[#0E7A3B]">se prononcer partout.</span>
          </h2>
          <MarketFriezeMini className="mt-7 max-w-[240px]" />
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {BLOCKS.map((b) => (
            <div
              key={b.letter}
              className="group relative overflow-hidden rounded-3xl bg-[#FBFAF6] border border-[#EDE7D9] p-8 md:p-10 hover:-translate-y-1 transition-transform duration-500"
            >
              <p
                className="font-display font-bold text-[7rem] md:text-[9rem] leading-none tracking-tighter"
                style={{ color: b.color }}
              >
                {b.letter}
              </p>
              <div className="mt-2">
                <div className="h-1 w-14 rounded-full mb-4" style={{ background: b.color }} />
                <h3 className="font-display text-2xl md:text-3xl text-[#16241B] tracking-tight">
                  {b.title}
                </h3>
                <p className="mt-3 text-[#16241B]/75 text-base leading-relaxed">
                  {b.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="rounded-3xl bg-[#16241B] text-white p-8 md:p-10 relative overflow-hidden noise-overlay">
            <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#F5A800]">
              Clin d'œil
            </p>
            <p className="mt-5 font-display text-2xl md:text-3xl leading-snug">
              Et en arabe,{" "}
              <span className="text-[#F5A800] italic">zafar</span> veut dire{" "}
              <span className="text-[#F5A800]">victoire</span>. On a trouvé ça
              de bon augure.
            </p>
          </div>

          <div className="rounded-3xl bg-white border border-[#EDE7D9] p-8 md:p-10">
            <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#0E7A3B]">
              L'idée directrice
            </p>
            <p className="mt-5 font-display text-2xl md:text-3xl text-[#16241B] leading-snug tracking-tight">
              Un nom que{" "}
              <span className="text-[#0E7A3B]">tout le monde</span> peut
              prononcer — de la bonne dame du marché à la diaspora.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
